import BaseAction from "base/base.action";
import { ChatHistoryType } from "domain/types/chatHistory.type";
import { ChatHistoryRequest } from "model/chatHistory/chatHistory.request";
import { ChatHistoryResponse } from "model/chatHistory/chatHistory.response";

export const fetchChatHistoryRequestAction = (params: ChatHistoryRequest) => {
  return BaseAction(ChatHistoryType.FETCH_CHAT_HISTORY_REQUEST, { params });
};

export const fetchChatHistorySuccessAction = (response: ChatHistoryResponse) => {
  return BaseAction(ChatHistoryType.FETCH_CHAT_HISTORY_SUCCESS, {
    chats: response.chats,
    totalRecords: response.total_rec,
  });
};

export const fetchChatHistoryFailureAction = (error: string) => {
  return BaseAction(ChatHistoryType.FETCH_CHAT_HISTORY_FAILURE, { error });
};
